export default __webpack_public_path__ + "static/media/KiwiDTO.e5fe2eac.mp4";